<template>
  <div class="collections-button" @click="showModal">
    <BbIcon class="collections-icon" name="collection" type="filled" size="small" />
    <TextBody i18n-key="collections.collections" tag="span" :body-type="2" weight="medium" />
    <div v-if="collectionsCount" class="collections-count">
      {{ collectionsCount }}
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

import { CURRENT_DIALOG } from '~/constants/conversationModels';

import useModals from '~/composables/useModals';
import useCollections from '~/composables/useCollections';
import TextBody from '@/components/common/TextBody.vue';

export default {
  name: 'CollectionsMenu',
  components: { TextBody },

  setup() {
    const { setCurrentDocumentsDialog } = useModals();
    const { currentCollections } = useCollections();
    const collectionsCount = computed(() => currentCollections.value.length);
    const showModal = () => {
      setCurrentDocumentsDialog(CURRENT_DIALOG.collections_panel);
    };

    return {
      collectionsCount,
      showModal,
    };
  },
};
</script>

<style scoped lang="scss">
.collections-button {
  position: relative;
  padding: $bb-spacing-2 $bb-spacing-4;
  border-radius: 100px;
  cursor: pointer;
  border: 1px solid $bb-neutral-4;
  height: 36px;
  display: flex;
  align-items: inherit;
  justify-content: center;
  gap: $bb-spacing-1;

  .collections-icon {
    color: $bb-neutral-1;
  }

  .collections-count {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-1;
    background-color: $bb-neutral-0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -4px;
    right: -6px;
    width: 18px;
    height: 16px;
    border: 1px solid $bb-neutral-4;
    border-radius: 100px;
  }
}
</style>
